import React from 'react';
import ReactTable from 'react-table';
import Pagination from '../../../components/DatatablePagination';
import { AddCommaNumber } from '../../../helpers/Utils';

const ContentMultiForm = (props) => {
    const { data, make_products } = props;
    // const make_product = make_products.filter(
    //     (product) => product.product_id === data.product_id
    // );
    // // console.log('make_product: ', make_product);

    // let priceCost = make_product
    //     .map((item) => {
    //         let price = data_stocks?.find(
    //             (i) => i.id === item.stock.id
    //         )?.avarage_price;
    //         // console.log('data_stocks: ', data_stocks);
    //         // console.log('price: ', price);
    //         return parseFloat(price);
    //     })
    //     .reduce((sum, item) => sum + item, 0);

    // console.log('data: ', data);
    // console.log('make_products: ', make_products);
    // console.log('priceCost: ', priceCost);
    
// console.log('render ContentMultiForm');

    const columns = [
        {
            Header: 'Tên sản phẩm',
            accessor: 'name',
            Cell: (props) => (
                <span className='text-capitalize'>{props.value}</span>
            ),
        },
        {
            Header: 'Barcode',
            accessor: 'barcode',
            Cell: (props) => (
                <span className='text-uppercase'>{props.value}</span>
            ),
        },
        {
            Header: 'SKU',
            accessor: 'sku',
            Cell: (props) => (
                <span className='text-uppercase'>{props.value}</span>
            ),
        },
        {
            Header: 'Danh mục',
            accessor: 'category',
            Cell: (props) => (
                <span className='text-capitalize'>{props.value.name}</span>
            ),
        },
        {
            Header: 'Khuyên dùng',
            accessor: 'bestter',
            Cell: (props) =>
                props.value === true ? (
                    <i className='simple-icon-check text-primary' />
                ) : (
                    ''
                ),
        },
        {
            Header: 'Giá bán',
            accessor: 'price',
            Cell: (cellProps) => {
                const { original } = cellProps; // original chứa toàn bộ object của dòng đó
                if (original.active_sale === true && original.price_sale && original.price_sale !== '0') {
                    return (
                        <span>
                            <span className='text-muted text-small text-deco-line-through mr-2'>
                                {AddCommaNumber(original.price)}
                            </span>
                            <span style={{ fontWeight: 'bold' }}>
                                {AddCommaNumber(original.price_sale)}
                            </span>
                        </span>
                    );
                }
                return AddCommaNumber(original.price); // Hoặc AddCommaNumber(cellProps.value)
            },
        },
        {
            Header: 'Giá khuyến mãi',
            accessor: 'price_sale',
            Cell: (props) =>
                props.value === '0' ? (
                    <i className='simple-icon-close' />
                ) : (
                    AddCommaNumber(props.value)
                ),
        },
        // {
        //     Header: 'Giá mua',
        //     accessor: 'price_cost',
        //     Cell: (cellProps) => {
        //         const { original } = cellProps; // original chứa toàn bộ object của dòng đó
        //         if (original.active_sale === true && original.price_sale && original.price_sale !== '0') {
        //             return (
        //                 <span>
        //                     <span className='text-muted text-small text-deco-line-through mr-2'>
        //                         {AddCommaNumber(original.price)}
        //                     </span>
        //                     <span style={{ fontWeight: 'bold' }}>
        //                         {AddCommaNumber(original.price_sale)}
        //                     </span>
        //                 </span>
        //             );
        //         }
        //         return AddCommaNumber(original.price); // Hoặc AddCommaNumber(cellProps.value)
        //     },
        // },
        // {
        //     Header: 'Phần trăm giá cost/giá bán',
        //     accessor: 'percent_cost',
        //     Cell: (props) =>
        //         props.value === '0' ? (
        //             <span className='text-muted'>Chưa thiết lập định lượng</span>
        //         ) : (
        //             AddCommaNumber(props.value)
        //         ),
        // },
        {
            Header: 'Đang khuyến mãi',
            accessor: 'active_sale',
            Cell: (props) =>
                props.value === true ? (
                    <i className='simple-icon-check text-primary' />
                ) : (
                    <i className='simple-icon-close' />
                ),
        },
        {
            Header: 'Ẩn/hiện',
            accessor: 'softHide',
            Cell: (props) => (props.value === true ? 'Đang ẩn' : 'Đang hiện'),
        },
    ];
    return (
        <ReactTable
            defaultPageSize={20}
            data={data}
            columns={columns}
            minRows={0}
            showPageJump={false}
            showPageSizeOptions={true}
            PaginationComponent={Pagination}
            NoDataComponent={() => null}
        />
    );
};

export default ContentMultiForm;
